<div id="breadcrumb-item">{{breadCrumbText}}</div>

